export default "__VITE_PUBLIC_ASSET__71761d2c__"